import { skipToken } from '@reduxjs/toolkit/query/react'
import { useFetchInfluencerLinkAnalysisQuery } from '@/api/influencer-api'
import { useFetchKolsKolLinkAnalysisQuery } from '@/api/k6-kols-api'
import { useFetchUserStatusQuery } from '@/api/user-api'
import { useFetchKolLinkAnalysisQuery } from '@/api/workspace-api/kol-api'
import useIsPublicDetailPage from '@/hooks/use-is-public-detail-page'
import { usePermissions } from '@/hooks/use-permissions'
import {
  LinkAnalysis,
  Platform,
} from '@/tests/mock-data/mock-content-distribution'
import convertFetchKolLinkAnalysisResponseToLinkAnalysis from '@/utils/kol/convert-fetch-kol-link-analysis-response-to-link-analysis'

type UseLinkAnalyze = (params: { kolId?: string; kolDcIdHashed?: string }) => {
  linkAnalysis?: LinkAnalysis[]
  isFetching: boolean
}

const useLinkAnalyze: UseLinkAnalyze = ({ kolId, kolDcIdHashed }) => {
  const { withKolPermission } = usePermissions()
  const isPublicKolDetailPage = useIsPublicDetailPage()

  const { data: userStatus, isFetching: isFetchingUserStatus } =
    useFetchUserStatusQuery(withKolPermission ? skipToken : undefined)

  const { data: linkAnalyzeByAd, isFetching: isFetchingLinkAnalyzeByAd } =
    useFetchKolLinkAnalysisQuery(
      !withKolPermission &&
        userStatus?.currentWorkspaceId &&
        kolId &&
        !isPublicKolDetailPage
        ? {
            workspaceId: userStatus.currentWorkspaceId,
            radar_uuid: kolId,
            dc_id_hashed: kolDcIdHashed,
          }
        : skipToken,
    )

  const { data: linkAnalyzeByKol, isFetching: isFetchingLinkAnalyzeByKol } =
    useFetchInfluencerLinkAnalysisQuery(
      withKolPermission && kolId && !isPublicKolDetailPage ? kolId : skipToken,
    )

  const {
    data: linkAnalyzeByPublic,
    isFetching: isFetchingLinkAnalyzeByPublic,
  } = useFetchKolsKolLinkAnalysisQuery(
    isPublicKolDetailPage && kolId
      ? {
          uuid: kolId,
        }
      : skipToken,
  )

  const linkAnalyze = ((): Platform | undefined => {
    if (isPublicKolDetailPage) {
      return linkAnalyzeByPublic
    }
    if (withKolPermission) {
      return linkAnalyzeByKol
    }
    return linkAnalyzeByAd
  })()

  return {
    linkAnalysis: linkAnalyze
      ? convertFetchKolLinkAnalysisResponseToLinkAnalysis(linkAnalyze)
      : [],
    isFetching:
      isFetchingUserStatus ||
      isFetchingLinkAnalyzeByAd ||
      isFetchingLinkAnalyzeByKol ||
      isFetchingLinkAnalyzeByPublic,
  }
}

export default useLinkAnalyze
